import { reactive } from 'vue'

// Estado reactivo para el tema
const state = reactive({
  isDarkMode: false
})

// Theme Manager
const themeManager = {
  // Getters
  get isDarkMode() {
    return state.isDarkMode
  },

  get themeClass() {
    return state.isDarkMode ? 'dark-theme' : 'light-theme'
  },

  // Methods
  toggleTheme() {
    state.isDarkMode = !state.isDarkMode
    this.applyTheme()
    this.saveToStorage()
  },

  setDarkMode(value) {
    state.isDarkMode = value
    this.applyTheme()
    this.saveToStorage()
  },

  applyTheme() {
    if (state.isDarkMode) {
      document.documentElement.classList.add('dark-theme')
      document.documentElement.classList.remove('light-theme')
    } else {
      document.documentElement.classList.add('light-theme')
      document.documentElement.classList.remove('dark-theme')
    }
  },

  saveToStorage() {
    localStorage.setItem('sicecom-theme', state.isDarkMode ? 'dark' : 'light')
  },

  loadFromStorage() {
    const savedTheme = localStorage.getItem('sicecom-theme')
    if (savedTheme) {
      state.isDarkMode = savedTheme === 'dark'
    } else {
      // Default to light theme
      state.isDarkMode = false
    }
    this.applyTheme()
  },

  init() {
    this.loadFromStorage()
  }
}

export default themeManager